// extracted by mini-css-extract-plugin
export default {"main":"styles_main__LSp1O","mobile":"styles_mobile__wnr2X","mobileEmpty":"styles_mobileEmpty__e+f+D","header":"styles_header__jPRck","description":"styles_description__xnzL6"};